import React from 'react'; 

export const BannerInfo: React.FC = () => {
  return (
    <div className="bg-gradient-to-r from-black to-[#666666]  text-white p-12 mb-8 shadow-lg text-center border-amber-300 border-b-8">
      <h1 className="text-4xl mb-2 max-w-5xl m-auto">¡SMARTCOMMS te da la bienvenida!</h1>
      <p className="text-lg max-w-2xl m-auto">
        Bienvenido a la plataforma donde podrás crear tus templates de combos y banners que se verán reflejados en BEES.
      </p>
    </div>
  );
};
